<template>
  <v-card class="mr-3 ml-3 mb-3 pa-3">
    <v-card-title>
      <!--      <span class="headline">{{ dealer.name }}</span>-->
      <span class="headline">Мастер-лицензия № {{masterId}}</span>
      <v-spacer></v-spacer>
      <v-btn color="warning" text @click="back">Назад</v-btn>
    </v-card-title>
    <v-tabs
        v-model="tab"
        color="green"
        :grow="true"
    >
      <v-tab
          v-for="item in items"
          :key="item.tab"
          :disabled="item.disabled"
          class="inactive-tab"
          active-class="active-tab"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab"
    >
      <v-tab-item
          v-for="item in items"
          :key="item.tab"
      >
        <component
            :key="masterId"
            :is="item.component"
            v-bind="{masterId}"
            @ready="loading = false"
            @update="updateLicenses"
            :ref="item.component"
        ></component>
      </v-tab-item>
    </v-tabs-items>

    <v-overlay
        :value="loading"
        absolute
    >
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>

<script>
import MasterEdit from "@/components/Master/MasterEdit";
import MasterLicenses from "@/components/Master/MasterLicenses";

export default {
  name: 'Master',
  props: ['masterId'],
  components: {
    MasterEdit,
    MasterLicenses,
  },
  data() {
    return {
      loading: true,
      tab: null,
      // dealer: {},
      items: [
        {
          tab: 'Свойства',
          component: 'MasterEdit',
        },
        {
          tab: 'Лицензии',
          component: 'MasterLicenses',
        },
      ],
    }
  },
  methods: {
    updateLicenses() {
      if (this.$refs.MasterLicenses) {
        this.$refs.MasterLicenses[0].getMasterLicenses();
      }
    },
    back() {
      history.back();
    },
  },
  watch: {
    masterId: function () {
      this.tab = 0;
      this.loading = true;
    },
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'masters', disabled: false, to: '/masters', exact: true},
      {text: this.masterId, disabled: true},
    ])
  },
}
</script>